module.exports = new __parcel__URL__("gordos.e03f6cf4.png").toString();